import React from "react";
import {Modal} from "../../SharedComponents";
import {ModalNames} from "../../../Constants/modalNames";
import {useModal} from "../../../Store/modules/modal/modal";
import {useLanguage} from "../../../Store/modules/language";
import {Div, Icon, Text} from "../../Kit";
import {Button} from "../../Kit/Button";
import {useTheme} from "../../../Store/modules/theme";
import {Add} from "iconsax-react";
import settings from "../../../settings/settings";
import {useUserLogout} from "../../../Store/modules/ai/userLogout/userLogout";

export const LogoutModal: React.FC = () => {
    const {direction} = useLanguage();
    const {dispatchCloseModal} = useModal();
    const {name: themeStatus} = useTheme();
    let {dispatchUserLogout ,userLogoutLoading} = useUserLogout();

    const { modalProps } = useModal();
    const { router } = modalProps || {};

    const logout = () => dispatchUserLogout(router,dispatchCloseModal);

    return (
        <Modal
            modalName={ModalNames.LogoutModal}
            modalClassName="rounded-[10px] relative w-[327px] flex flex-col justify-between items-center"
        >
            <Div
                dir={direction}
                bg="forthOpt"
                className="w-[27px] h-[27px] flex items-center justify-center pointer rounded-[50%] absolute right-[10px] top-[10px] "
                onClick={() => dispatchCloseModal()}
            >
                <Icon
                    Component={Add}
                    size={20}
                    className="rotate-[45deg]"
                    color="text"
                />
            </Div>
            <div dir={direction} className="flex justify-center pt-[10px]">
                <img src={settings.logo?.[themeStatus]} alt="logo" className="w-[60px]"/>
            </div>
            <div className="py-5 text-start">
                <Text elementType="span" className="text-sm">profile.youWantToLogOut</Text>
            </div>
            <div className="flex flex-row items-center justify-center gap-2">
                <Button
                    title="profile.logOut"
                    className="w-full h-[40px] flex-[2]"
                    textClassName="text-sm"
                    loading={userLogoutLoading}
                    bg="primary"
                    onClick={logout}
                />
                <Button
                    title="cancel"
                    bg="transparent"
                    borderWidth="1px"
                    borderColor="primary"
                    borderStyle="solid"
                    textColor="primary"
                    textClassName="text-sm"
                    className="w-full h-[40px] flex-[1]"
                    onClick={dispatchCloseModal}
                />
            </div>
        </Modal>
    );
};